import { api } from './_barrel.js';


        // ---- AEA Exposure tab -------------------------------------------------
        // Physical-movement exposure from broker-sold location history. All data
        // is consent-gated server-side; this panel simply renders what the
        // /api/v1/aea endpoints return and never plots anything for a device
        // whose consent has lapsed (the API returns locked=true and no points).
        const AEA_PLACE = {
            home_inferred:  { color: 'var(--red)',    label: 'H', name: 'Home (inferred)' },
            work_inferred:  { color: 'var(--amber)',  label: 'W', name: 'Work (inferred)' },
            routine:        { color: 'var(--gold)',   label: 'R', name: 'Routine place' },
            sensitive:      { color: 'var(--red)',    label: 'S', name: 'Sensitive place' },
            transient:      { color: 'var(--muted)',  label: '·', name: 'Transient' },
        };

export { AEA_PLACE };
